import React from 'react';

interface Props {
  fill: string;
  width?: string;
}

const Brand: React.FC<Props> = ({ fill, width = '200px' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 318 69">
      <path
        id="Connectd"
        fill={fill}
        stroke={fill}
        strokeWidth="1"
        d="M 45.97,40.16
           C 45.97,40.16 54.94,43.00 54.94,43.00
             53.56,48.00 51.27,51.71 48.08,54.14
             44.88,56.57 40.82,57.78 35.91,57.78
             29.82,57.78 24.82,55.70 20.91,51.55
             16.99,47.39 15.03,41.71 15.03,34.50
             15.03,26.88 17.00,20.95 20.94,16.73
             24.88,12.52 30.05,10.41 36.47,10.41
             42.07,10.41 46.62,12.06 50.12,15.38
             52.21,17.34 53.77,20.15 54.81,23.81
             54.81,23.81 45.66,26.00 45.66,26.00
             45.11,23.62 43.98,21.75 42.27,20.38
             40.55,19.00 38.46,18.31 36.00,18.31
             32.60,18.31 29.85,19.53 27.73,21.97
             25.62,24.41 24.56,28.36 24.56,33.81
             24.56,39.61 25.60,43.73 27.69,46.19
             29.77,48.65 32.48,49.88 35.81,49.88
             38.27,49.88 40.38,49.09 42.16,47.53
             43.93,45.97 45.20,43.51 45.97,40.16 Z
           M 60.56,39.94
           C 60.56,37.02 61.28,34.20 62.72,31.47
             64.16,28.74 66.19,26.66 68.83,25.22
             71.46,23.78 74.41,23.06 77.66,23.06
             82.68,23.06 86.79,24.70 90.00,27.95
             93.21,31.21 94.81,35.34 94.81,40.31
             94.81,45.34 93.19,49.50 89.95,52.80
             86.71,56.10 82.63,57.75 77.72,57.75
             74.68,57.75 71.77,57.06 69.02,55.69
             66.25,54.31 64.16,52.30 62.72,49.64
             61.28,46.98 60.56,43.75 60.56,39.94 Z
           M 69.56,40.41
           C 69.56,43.70 70.34,46.22 71.91,47.97
             73.47,49.72 75.39,50.59 77.69,50.59
             79.98,50.59 81.90,49.72 83.45,47.97
             85.00,46.22 85.78,43.68 85.78,40.34
             85.78,37.09 85.00,34.59 83.45,32.84
             81.90,31.09 79.98,30.22 77.69,30.22
             75.39,30.22 73.47,31.09 71.91,32.84
             70.34,34.59 69.56,37.12 69.56,40.41 Z
           M 131.78,57.00
           C 131.78,57.00 123.00,57.00 123.00,57.00
             123.00,57.00 123.00,40.06 123.00,40.06
             123.00,36.48 122.81,34.16 122.44,33.11
             122.06,32.06 121.45,31.24 120.61,30.66
             119.77,30.07 118.75,29.78 117.56,29.78
             116.04,29.78 114.68,30.20 113.47,31.03
             112.26,31.87 111.43,32.97 110.98,34.34
             110.54,35.72 110.31,38.26 110.31,41.97
             110.31,41.97 110.31,57.00 110.31,57.00
             110.31,57.00 101.53,57.00 101.53,57.00
             101.53,57.00 101.53,23.81 101.53,23.81
             101.53,23.81 109.69,23.81 109.69,23.81
             109.69,23.81 109.69,28.69 109.69,28.69
             112.58,24.94 116.23,23.06 120.62,23.06
             122.56,23.06 124.33,23.41 125.94,24.11
             127.54,24.81 128.75,25.70 129.58,26.78
             130.40,27.87 130.97,29.09 131.30,30.47
             131.62,31.84 131.78,33.81 131.78,36.38
             131.78,36.38 131.78,57.00 131.78,57.00 Z
           M 170.78,57.00
           C 170.78,57.00 162.00,57.00 162.00,57.00
             162.00,57.00 162.00,40.06 162.00,40.06
             162.00,36.48 161.81,34.16 161.44,33.11
             161.06,32.06 160.45,31.24 159.61,30.66
             158.77,30.07 157.75,29.78 156.56,29.78
             155.04,29.78 153.68,30.20 152.47,31.03
             151.26,31.87 150.43,32.97 149.98,34.34
             149.54,35.72 149.31,38.26 149.31,41.97
             149.31,41.97 149.31,57.00 149.31,57.00
             149.31,57.00 140.53,57.00 140.53,57.00
             140.53,57.00 140.53,23.81 140.53,23.81
             140.53,23.81 148.69,23.81 148.69,23.81
             148.69,23.81 148.69,28.69 148.69,28.69
             151.58,24.94 155.23,23.06 159.62,23.06
             161.56,23.06 163.33,23.41 164.94,24.11
             166.54,24.81 167.75,25.70 168.58,26.78
             169.40,27.87 169.97,29.09 170.30,30.47
             170.62,31.84 170.78,33.81 170.78,36.38
             170.78,36.38 170.78,57.00 170.78,57.00 Z
           M 198.81,46.44
           C 198.81,46.44 207.56,47.91 207.56,47.91
             206.44,51.12 204.66,53.56 202.23,55.23
             199.80,56.91 196.77,57.75 193.12,57.75
             187.35,57.75 183.08,55.87 180.31,52.09
             178.12,49.07 177.03,45.26 177.03,40.66
             177.03,35.16 178.47,30.85 181.34,27.73
             184.22,24.62 187.85,23.06 192.25,23.06
             197.19,23.06 201.08,24.70 203.94,27.95
             206.79,31.21 208.16,36.21 208.03,42.94
             208.03,42.94 186.03,42.94 186.03,42.94
             186.09,45.54 186.80,47.57 188.16,49.02
             189.51,50.46 191.20,51.19 193.22,51.19
             194.59,51.19 195.75,50.81 196.69,50.06
             197.62,49.31 198.33,48.11 198.81,46.44 Z
           M 199.31,37.56
           C 199.25,35.02 198.59,33.09 197.34,31.77
             196.09,30.45 194.57,29.78 192.78,29.78
             190.86,29.78 189.28,30.48 188.03,31.88
             186.78,33.27 186.16,35.17 186.19,37.56
             186.19,37.56 199.31,37.56 199.31,37.56 Z
           M 244.53,33.62
           C 244.53,33.62 235.88,35.19 235.88,35.19
             235.58,33.46 234.92,32.16 233.89,31.28
             232.86,30.41 231.52,29.97 229.88,29.97
             227.69,29.97 225.94,30.73 224.64,32.23
             223.34,33.75 222.69,36.27 222.69,39.81
             222.69,43.75 223.35,46.53 224.67,48.16
             225.99,49.78 227.77,50.59 230.00,50.59
             231.66,50.59 233.03,50.12 234.09,49.17
             235.16,48.23 235.91,46.59 236.34,44.28
             236.34,44.28 244.97,45.75 244.97,45.75
             244.07,49.71 242.35,52.70 239.81,54.72
             237.27,56.74 233.86,57.75 229.59,57.75
             224.74,57.75 220.87,56.22 217.98,53.16
             215.10,50.09 213.66,45.86 213.66,40.44
             213.66,34.96 215.10,30.70 218.00,27.64
             220.89,24.59 224.81,23.06 229.75,23.06
             233.79,23.06 237.00,23.93 239.39,25.67
             241.77,27.41 243.49,30.06 244.53,33.62 Z
           M 266.81,23.81
           C 266.81,23.81 266.81,30.81 266.81,30.81
             266.81,30.81 260.81,30.81 260.81,30.81
             260.81,30.81 260.81,44.19 260.81,44.19
             260.81,46.90 260.87,48.48 260.98,48.92
             261.10,49.37 261.36,49.74 261.77,50.03
             262.17,50.32 262.66,50.47 263.25,50.47
             264.06,50.47 265.24,50.19 266.78,49.62
             266.78,49.62 267.53,56.44 267.53,56.44
             265.49,57.31 263.18,57.75 260.59,57.75
             259.01,57.75 257.58,57.48 256.31,56.95
             255.04,56.42 254.11,55.73 253.52,54.89
             252.92,54.05 252.51,52.91 252.28,51.47
             252.09,50.45 252.00,48.39 252.00,45.28
             252.00,45.28 252.00,30.81 252.00,30.81
             252.00,30.81 247.97,30.81 247.97,30.81
             247.97,30.81 247.97,23.81 247.97,23.81
             247.97,23.81 252.00,23.81 252.00,23.81
             252.00,23.81 252.00,17.22 252.00,17.22
             252.00,17.22 260.81,12.09 260.81,12.09
             260.81,12.09 260.81,23.81 260.81,23.81
             260.81,23.81 266.81,23.81 266.81,23.81 Z
           M 303.03,57.00
           C 303.03,57.00 294.88,57.00 294.88,57.00
             294.88,57.00 294.88,52.12 294.88,52.12
             293.52,54.02 291.92,55.43 290.08,56.36
             288.23,57.29 286.38,57.75 284.50,57.75
             280.69,57.75 277.42,56.21 274.70,53.14
             271.98,50.07 270.62,45.78 270.62,40.28
             270.62,34.66 271.95,30.38 274.59,27.45
             277.24,24.53 280.58,23.06 284.62,23.06
             288.33,23.06 291.54,24.61 294.25,27.69
             294.25,27.69 294.25,11.19 294.25,11.19
             294.25,11.19 303.03,11.19 303.03,11.19
             303.03,11.19 303.03,57.00 303.03,57.00 Z
           M 279.59,39.69
           C 279.59,43.23 280.08,45.79 281.06,47.38
             282.48,49.67 284.46,50.81 287.00,50.81
             289.02,50.81 290.74,49.95 292.16,48.23
             293.57,46.52 294.28,43.95 294.28,40.53
             294.28,36.72 293.59,33.98 292.22,32.30
             290.84,30.62 289.08,29.78 286.94,29.78
             284.85,29.78 283.11,30.61 281.70,32.27
             280.30,33.92 279.59,36.40 279.59,39.69 Z"
      />
    </svg>
  );
};

export default Brand;
